import { withSession } from '@zipdrug/react-api-sdk';
import { queryUsers } from 'graphql/users';
import { get } from 'lodash';
import { graphql } from '@apollo/client/react/hoc';
import withRoles from './withRoles';
import fetchOnceOptions from './utils/fetchOnceOptions';

export const buildUserQueryVariables = ({
  isPbsTeam,
  isPharmacistTeam,
  isPharmacyTeam,
  hasRole,
}) => {
  const query = { extras: { isTeam: true } };
  if (isPbsTeam) {
    query.roles = { user_group: 'pbs' };
  } else if (hasRole.pharmacyAsc || hasRole.pharmacyAscAdmin) {
    query.roles = { user_group: ['pharmacy', 'pharmacyteam'] };
  } else if (isPharmacyTeam) {
    query.roles = { user_group: 'pharmacyteam' };
  } else if (isPharmacistTeam) {
    query.roles = { user_group: 'pharmacy' };
  }
  return query;
};

export default function withUsers(Component) {
  const ComponentWithData = graphql(queryUsers, {
    skip: ({ userId }) => !userId,
    options: props =>
      fetchOnceOptions('users', {
        variables: {
          query: buildUserQueryVariables(props),
        },
      }),
    props: ({ data: { loading: isLoading, users: result, refetch }, ownProps }) => ({
      ...ownProps,
      isLoading,
      users: get(result, 'data', []).filter(u => u && !u.deleted_at && u.id !== ownProps.userId),
      onUserDeleted: () => refetch && refetch(),
    }),
  })(Component);

  return withSession(withRoles(ComponentWithData));
}
